import React, { Component } from 'react';
import PostsTable from './components/PostsTable';

class PostsCard extends Component {

  render() {
    return <PostsTable />
  }

}

export default PostsCard;
